class ScrollFollow {
	private static scrollFollowClasses = ["pin-top", "follow", "pin-bottom", "fixed"];

	setClass(element: HTMLElement, className: string, setTop: string | null = null) {
		if (element.classList.contains(className)) {
			return;
		}
		ScrollFollow.scrollFollowClasses.filter(x => x !== className).forEach(removeClass => {
			element.classList.remove(removeClass);
		});
		element.classList.add(className);
		element.style.top = setTop ?? "";
	}

	positionScrollFollow(element: HTMLElement) {
		// Run this code between FPS frames. This will make the page run smoother as updates are not happenning between FPS frames.
		requestAnimationFrame(() => {
			// debugger;
			const windowHeight = window.innerHeight;
			const elementBoundingRec = element.getBoundingClientRect();
			const parentBoundingRec = element.parentElement?.getBoundingClientRect();

			if(!parentBoundingRec) {
				return;
			}

			const elementExtendsBelowWindow = elementBoundingRec.bottom > windowHeight;
			const parentBelowTopOfWindow = parentBoundingRec.top >= 0;
			const topAlignment = Math.min(0, windowHeight - elementBoundingRec.height);
			const elementAboveTopOfParent = elementBoundingRec.top < parentBoundingRec.top;

			const pinToTop = parentBelowTopOfWindow || elementExtendsBelowWindow || elementAboveTopOfParent;

			// If the element bottom will extend below the bottom of the parent, pin it to the bottom.
			const pinToBottom = elementBoundingRec.height + topAlignment >= parentBoundingRec.bottom;

			if (parentBoundingRec.height <= elementBoundingRec.height + 100) {
				// If the scroll follow is the smae height or bigger than the contents, leave it in a fixed position.
				this.setClass(element, "fixed");
			} else if (pinToTop) {
				// Pin the scroll follow to the top of the parent element.
				this.setClass(element, "pin-top");
			} else if (pinToBottom) {
				// Pin the scroll follow element to the bottom of the parent element.
				this.setClass(element, "pin-bottom");
			} else {
				// Pin the scroll follow to a sopt on the visible window so it is following you down the page.
				this.setClass(element, "follow", `${topAlignment}px`);
			}
		});
	}

	init() {
		const scrollFollowElements: HTMLElement[] = Array.from(document.querySelectorAll(".scroll-follow"));
		if (scrollFollowElements.length === 0) {
			return;
		}

		scrollFollowElements.forEach(scrollFollowElement => {
			this.positionScrollFollow(scrollFollowElement);

			window.addEventListener("scroll", () => {
				this.positionScrollFollow(scrollFollowElement);
			});
		});
	};
}

window.addEventListener("DOMContentLoaded", () => {
	const scrollFollow = new ScrollFollow();
	scrollFollow.init();
});
